export default {
    namespaced: true,
    state: () => ({
        treatment: null,
        selectedEmbryoId: null,
        birthYear: null,
        clinicDetail: {}
    }),
    getters: {},
    mutations: {
        treatment(state, treatment) {
            state.treatment = treatment
        },
        birthYear(state, birthYear) {
            state.birthYear = birthYear
        },
        selectedEmbryoId(state, wellId) {
            state.selectedEmbryoId = wellId
        },
        clinicDetail(state, clinicDetail) {
            state.clinicDetail = clinicDetail
        }
    }
}
